export default {
  title: 'Pomoc i FAQ',
  buttons: {
    faqs: 'FAQ',
    contact_us: 'Skontaktuj się z nami',
  },
};
